import React, { useState } from "react";
import "./shareOptionCampaign.scss";
import {
  WhatsappShareButton,
  WhatsappIcon,
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import { IoIosLink } from "react-icons/io";

export default function ShareOptions({ setShowShareOptions, url }) {
  const [copied, setCopied] = useState(false);

  const messageQuote =
    "Thank you for keeping Maa's blessings with you this Durga Puja. Share this joy with your loved ones.";

  // function to copy text to clipboard
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div
      className="PujaCampaignShareOptions flex-row-center"
      onClick={() => setShowShareOptions(false)}
    >
      {url && (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex-row-center share"
        >
          <WhatsappShareButton
            url={`${messageQuote}\n\n${url}`}
            // onClick={() => handleSharePlausible("WhatsApp")}
          >
            <WhatsappIcon round={true} />
          </WhatsappShareButton>

          <FacebookShareButton url={url}>
            <FacebookIcon round={true} />
          </FacebookShareButton>

          {/* <LinkedinShareButton url={url}>
            <LinkedinIcon round={true} />
          </LinkedinShareButton> */}

          <TwitterShareButton
            url={`${messageQuote}\n\n${url}`}
            // title={messageQuote}
            hashtags={["snapshawt", "techkilla"]}
          >
            <TwitterIcon round={true} />
          </TwitterShareButton>

          <span className="copyBtn flex-row-center" onClick={handleCopy}>
            <IoIosLink />
            {copied && <span className="copied">Copied!</span>}
          </span>

          <div className="closeIcon" onClick={() => setShowShareOptions(false)}>
            <i className="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>
      )}
    </div>
  );
}
